import { FormControl, FormGroup } from '@angular/forms';
import { CreateProductFormControls, ICreateProductControls } from '../../../../../assets/descriptors';
import { BaseProductForm } from './base-product.form';

export class CreateProductForm extends BaseProductForm<ICreateProductControls> {
    protected customValidateForm(): boolean {
        return true;
    }

    initForm(): void {
        this.form = new FormGroup({});
        this.controls = CreateProductFormControls();

        Object.keys(this.controls).forEach((key: string) => {
            const control = this.controls[key];

            this.form.addControl(control.name, new FormControl(control.value, control.validators));
        });
    }
}
